import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function CancelStockCountDialog({
  open,
  loading = false,
  error = "",
  onClose,
  onConfirm,
}) {
  function handleClose() {
    if (!loading) onClose?.();
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : handleClose}
      PaperProps={{ sx: { borderRadius: "24px", maxWidth: 480 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, color: "primary.900" }}>
        Confirmar cancelacion
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "neutral.700", fontSize: 14, fontWeight: 650 }}>
          Vas a anular la solicitud. La lista quedara en modo de solo lectura y
          esta accion no se puede deshacer.
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ mt: 1.5, borderRadius: "16px" }}>
            {error}
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          type="button"
          onClick={handleClose}
          disabled={loading}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Volver
        </Button>
        <Button
          type="button"
          variant="contained"
          color="error"
          disabled={loading}
          onClick={onConfirm}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          {loading ? "Cancelando..." : "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
